// src/api/index.ts
import createAxiosInstance from "./AxiosInsance";

export const centralApi = createAxiosInstance(process.env.REACT_APP_CENTRAL_API_URL!);
export const feedbackApi = createAxiosInstance(process.env.REACT_APP_FEEDBACK_API_URL!);
export const userApi = createAxiosInstance(process.env.REACT_APP_USER_API_URL!);
export const jobApi = createAxiosInstance(process.env.REACT_APP_JOB_API_URL!);
export const offerApi = createAxiosInstance(process.env.REACT_APP_OFFER_API_URL!);
export const interviewService = createAxiosInstance(process.env.REACT_APP_INTERVIEW_API_URL!);
